export const ERROR_STATUS_CLASS = 'field-status-error'
export const SUCCESS_STATUS_CLASS = 'field-status-success'

export const ERROR_STATUS_SELECTOR = `.${ERROR_STATUS_CLASS}`
export const SUCCESS_STATUS_SELECTOR = `.${SUCCESS_STATUS_CLASS}`
